/**
 * @generated SignedSource<<ea808d7d4bcbf935a5e036ad1ab8e9cf>>
 * @relayHash 51e36c6d3b9cb18728c36d7ee21a8ead
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 277926a6d1bac32ee107b24cd9b12277cecd53a03cd03f045786f18f171e87b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "277926a6d1bac32ee107b24cd9b12277cecd53a03cd03f045786f18f171e87b9",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
